import { t } from 'i18next';
import CsvIcon from '../../../../../assets/images/export-csv-icon.svg';
import { BaseSelector, SelectorProps } from './BaseSelector';

export const CsvSelector = ({ selected, loading, disabled, disabledReason, description, onSelected }: SelectorProps) => {
  return (
    <BaseSelector
      title={t('csv')}
      description={description}
      icon={<CsvIcon aria-hidden="true" width="40" height="40" />}
      selected={selected}
      onSelected={onSelected}
      loading={loading ?? false}
      disabled={disabled ?? false}
      disabledReason={disabledReason}
    />
  );
};
